export default function radians(angle) {
  return (angle * Math.PI) / 180
}
